import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicOrderProcessRequest {
  @jsonMember(String)
  public readonly secureFormToken!: string;

  public constructor(
    private readonly data: {
      secureFormToken: string;
    },
  ) {
    this.secureFormToken = this.data.secureFormToken;
  }
}
